const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-star-fill',
      title: '最新マシン×結果重視',
      description: 'Fit Carving、Revcella、WellTerra、MOUMITUなど最先端の美容マシンを導入。一人ひとりの悩みに合わせた施術で、確実な結果を追求します。',
    },
    {
      icon: 'ri-map-pin-2-fill',
      title: '駅近・完全予約制のプライベート空間',
      description: '五位堂駅から徒歩2分の好立地。完全予約制で他のお客様と顔を合わせることなく、リラックスして施術を受けていただけます。',
    },
    {
      icon: 'ri-heart-fill',
      title: '体質やライフスタイルに合わせたオーダーメイド提案',
      description: 'カウンセリングを大切にし、お客様の体質、生活習慣、目標に合わせた最適なプランをご提案。無理なく続けられる美容習慣をサポートします。',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-semibold text-center text-dark-gray mb-16 md:mb-20">
          LUCIALLの3つの特徴
        </h2>
        <div className="space-y-8 md:space-y-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-beige rounded-3xl p-8 md:p-10 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-gold rounded-full mb-6">
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-dark-gray mb-4">
                  {feature.title}
                </h3>
                <p className="text-medium-gray leading-relaxed text-sm md:text-base max-w-2xl">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
